<template>
   <div>
       <!--处理咨询-->
       <el-dialog :visible.sync="visible" v-loading="loading" element-loading-text="保存中……"  class="doconsult" width="890px" :close-on-click-modal="false"  :before-close="beforeClose">
           <div slot="title">
               <z-title title="处理咨询"></z-title>
           </div>
           <el-form :model="data" :show-message="false" class="plr-20" :rules="rules"
                    size="medium" ref="data">
               <el-row>
                   <template v-if="wantDate">
                       <el-col :span="11">
                           <el-form-item label="跟进状态" prop="followState" label-width="110px" :show-message="false" :rules="checkedAlert?[]:[{required: true, trigger: 'change'}]">
                               <follow-state hidestate v-model="data.followState" placeholder="请选择跟进状态"
                                             :disabled="checkedAlert"   class="w-240"></follow-state>
                           </el-form-item>
                           <el-form-item label="意向场地" prop="wantHouse" label-width="110px" :show-message="false" :rules="checkedAlert||data.followState=='04'?[]:[{required: true, trigger: 'change'}]">
                               <want-house  v-model="data.wantHouse" multiple placeholder="请选择意向场地"
                                            @change="changeHouseInfo"        :disabled="checkedAlert||data.followState=='04'"  class="w-240"></want-house>
                           </el-form-item>
                           <el-form-item label="意向度" prop="wantLevelCode" label-width="110px" :show-message="false" :rules="checkedAlert||data.followState=='04'?[]:[{required: true, trigger: 'change'}]">
                               <want-level v-model="data.wantLevelCode" placeholder="请选择意向度"
                                           :disabled="checkedAlert||data.followState=='04'"   class="w-240"></want-level>
                           </el-form-item>
                           <el-form-item label="下次回访日期" prop="callbackDate"  label-width="110px"  :show-message="false" :rules="checkedAlert||data.followState=='04'?[]:[{required: true, trigger: 'change'}]">
                               <el-date-picker
                                       class="w-160"
                                       value-format="yyyy-MM-dd"
                                       v-model="data.callbackDate"
                                       :disabled="checkedAlert||data.followState=='04'"
                                       :picker-options="pickerOptions"
                                       type="date"
                                       placeholder="选择回访日期">
                               </el-date-picker>
                               <el-checkbox class="ml-10" v-model="checkedAlert">不提醒</el-checkbox>
                           </el-form-item>
                       </el-col>
                       <el-col :span="13" class="right">
                           <el-form-item label="备 注" prop="remark" :show-message="false" :rules="checkedAlert?[]:[{required: true, trigger: 'change'}]" style="height: 188px">
                               <el-input type="textarea" rows="6" show-word-limit v-model="data.remark"
                                         :disabled="checkedAlert"       resize="none"
                                         maxlength="512"></el-input>
                           </el-form-item>
                       </el-col>
                   </template>
                   <el-col>
                       <!--只显示10条-->
                       <div class="ptb-10 el-icon-s-data">处理记录</div>
                       <el-table
                               header-cell-class-name="headerrow"
                               cell-class-name="cellclass"
                               :data="detailData"
                               style="width: 100%">
                           <el-table-column
                                   align="center"
                                   prop="remark"
                                   label="备注"
                                   min-width="100">
                           </el-table-column>
                           <el-table-column
                                   prop="createTime"
                                   label="沟通日期"
                                   min-width="120"
                                   align="center">
                           </el-table-column>
                           <el-table-column
                                   fixed="right"
                                   prop="createUserName"
                                   label="经办人"
                                   width="100"
                                   align="center">
                           </el-table-column>
                       </el-table>
                   </el-col>
                   <el-col>
                       <el-form-item class="mt-10 flex-n fje " v-if="wantDate">
                           <el-button type="primary" @click="saveConsult">保 存</el-button>
                           <el-button @click="beforeClose">取 消</el-button>
                       </el-form-item>
                       <el-form-item class="mt-10 flex-n fje " v-else>
                           <el-button type="primary" @click="beforeClose">确 定</el-button>
                       </el-form-item>
                   </el-col>

               </el-row>
           </el-form>
       </el-dialog>
   </div>
</template>

<script>
    import FollowState from "../../../components/data/followState";
    import WantHouse from "../../../components/data/wantHouse";
    import WantLevel from "../../../components/data/wantLevel";
    import ZTitle from "../../../components/ZTitle";

    export default {
        components: {
            ZTitle,
            WantLevel,
            WantHouse,
            FollowState},
        name: "handle-consult",
        props:{
            visible:Boolean,
            wantDate:String,
            id:String,
        },
        data(){
            return{
                //处理咨询
                data: {
                    followState: '',//后台未定义
                    wantLevelCode: '',
                    callbackDate: '',
                    wantHouse: [],
                    remark: ''
                },
                detailData:[],
                wantHouse:[],
                //待处理咨询规则
                rules: {},
                loading:false,
                checkedAlert:false
            }
        },
        computed: {
            pickerOptions() {
                return {
                    firstDayOfWeek: 1,
                    disabledDate: time => (this.wantDate == null ? (time.getTime() < Date.now() - 24 * 60 * 60 * 1000) : (time.getTime() > new Date(this.wantDate).getTime() || time.getTime() < Date.now() - 24 * 60 * 60 * 1000))
                }
                //只能选今天之后的
            },
        },
        watch:{
            checkedAlert(newval, oldval) {
                if(newval){
                    this.data.callbackDate="";
                }
            },
            visible(newval,oldval){
                this.loading=true;
                this.askHandleById(this.id);
            },
            'data.followState'(newval,oldval){
                if(newval=='04'){
                    this.$set(this.data,'wantLevelCode','');
                    this.$set(this.data,'callbackDate','');
                    this.$set(this.data,'wantHouse',[]);
                }
            }
        },
        methods:{
            askHandleById(askId) {
                console.log(askId)
                this.$axios.post('/preUserAskRecord/askHandleById', {
                    "userAskId": askId
                }).then(res => {
                    console.log('处理明细', res)
                    this.detailData = res.data.list;
                    var data=this.detailData[0]||{}
                    var wantHouse=[],wantHouse2=[];
                    for(var i=0,len=data.wantHouse.length;i<len;i++){
                        if(data.wantHouse[i]){
                            wantHouse.push( data.wantHouse[i].houseId)
                            wantHouse2.push({
                                id: data.wantHouse[i].houseId,
                                houseName:data.wantHouse[i].houseName
                            })
                        }

                    }
                    console.log(data)
                    this.changeHouseInfo(wantHouse2)
                    this.data={
                        followState: data.followState=='01'?'02':data.followState,
                        wantLevelCode: data.wantLevelCode?data.wantLevelCode:'',
                        callbackDate: data.callbackDate?data.callbackDate:'',
                        wantHouse: wantHouse,
                        remark:''
                    }
                    this.loading=false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading=false;

                })
            },
            beforeClose() {
                this.$emit('update:visible', false)
            },
            changeHouseInfo(data){
                this.wantHouse=data;
            },
            //保存处理咨询
            saveConsult() {
                //验证
                this.$refs.data.validate((valid) => {
                    if (valid) {
                        this.loading=true;
                        var data = this.data;
                        var wantHouse=[]
                        for(var i in this.wantHouse){
                            wantHouse.push({houseId:this.wantHouse[i].id,houseName:this.wantHouse[i].houseName})
                        }
                        this.$axios.post("/preUserAskRecord/saveHandle", {
                            storeId: this.$root.getStorage('storeId'),
                            userAskId: this.id,
                            followState: data.followState,//后台未定义
                            wantLevelCode: data.wantLevelCode,
                            callbackDate: data.callbackDate,
                            wantHouse: wantHouse,
                            remark: data.remark
                        }).then(res => {
                            this.loading=false;
                            this.$emit('update:visible', false);

                            this.$message.success('保存成功！');
                            this.$emit('change');
                        }).catch(err => {
                            this.loading=false;
                            this.$message.error(err.msg);
                        })

                    } else {
                        this.$message.error('表单填写有误！');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .doconsult {
    .right {
        background: #f7f7f7;
        padding: 0 10px;
        height: fit-content;
    }
    }
</style>